import {Injectable} from '@angular/core';
import {SoilAnalysisUploadStore} from './soil-analysis-upload.store';
import {SoilAnalysisUploadQuery} from './soil-analysis-upload.query';
import {guid, ID, transaction} from '@datorama/akita';
import {getShareStateEntity} from '../../_shared/models/share-state-entity.model';
import {from, Observable, of, Subject} from 'rxjs';
import {catchError, concatMap, filter, tap} from 'rxjs/operators';
import {environment} from '@env/environment';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {SoilAnalysisFile} from './models/soil-analysis-file';
import {SoilAnalysisFileStatus} from './constants/soil-analysis-file-status';

@Injectable({providedIn: 'root'})
export class SoilAnalysisUploadService {

  constructor(private soilAnalysisUploadStore: SoilAnalysisUploadStore,
              private soilAnalysisUploadQuery: SoilAnalysisUploadQuery,
              private http: HttpClient) {
  }

  private showInfoBox: Subject<boolean> = new Subject<boolean>();
  showInfoBox$: Observable<boolean> = this.showInfoBox.asObservable();

  private updateStatus: Subject<void> = new Subject<void>();
  updateStatus$: Observable<void> = this.updateStatus.asObservable();

  private fileExtensions = ['.zip'];
  private fileSizeLimit = 50 * 1e+6;

  toggleInfoBox(show: boolean): void {
    this.showInfoBox.next(show);
  }

  @transaction()
  addFiles(files: File[]) {
    this.resetStore();
    this.updateStatus.next();
    this.showInfoBox.next(true);
    const fileList = Array.from(files);
    const filesDataList = fileList.map((f: File, index) => {
      const id = guid();
      const data = {name: f.name, size: f.size, status: SoilAnalysisFileStatus.Processing, index};
      const error = this.validateFile(f);
      return getShareStateEntity(id, data, !error, error);
    });
    this.soilAnalysisUploadStore.add(filesDataList);
    // send files
    from(filesDataList).pipe(
      filter(item => !item.error),
      concatMap((item) => this.uploadFile(fileList[item.data.index], item.id))
    ).subscribe();

  }

  private validateFile(file: File): string {
    const extension = file.name.slice(file.name.lastIndexOf('.'));
    const invalidExtensions = !this.fileExtensions.includes(extension);
    const invalidSize = !file.size || file.size > this.fileSizeLimit;
    if (invalidExtensions) {
      return 'invalidExtensions';
    } else if (invalidSize) {
      return 'invalidSize';
    }
    return null;
  }

  uploadFile(file: File, id: ID): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.apiRoot}/agriscouting/api/analyzes/single?fileId=${id}`, formData).pipe(
      tap((response) => {}),
      catchError(() => {
        // if (this.soilAnalysisUploadQuery.getEntity(id)) {
        //   const data = this.soilAnalysisUploadQuery.getEntity(id).data;
        //   this.soilAnalysisUploadStore.update(
        //     id,
        //     getShareStateEntity(id,
        //       {...data, status: error.status ? SoilAnalysisFileStatus.Error : SoilAnalysisFileStatus.Processing}, false,
        //       error.status === 400 ? error.error.message : (error.status === 0 ? 'cors_error' : error.status)
        //     )
        //   );
        //   return of(null);
        // }
        return of (null);
      })
    );
  }

  getStatusFile(): void {
    const filesId: ID[] = this.soilAnalysisUploadQuery.getAll()
      .filter(file => file.data.status === SoilAnalysisFileStatus.Processing || file.data.status === SoilAnalysisFileStatus.Error)
      .map(file => file.id);
    this.http.post(`${environment.apiRoot}/agriscouting/api/analyzes/statusFile`, filesId)
      .subscribe((res: SoilAnalysisFile[]) => {
        this.updateStatus.next();
        res.forEach(item => {
          this.soilAnalysisUploadStore.update(
            item.id, getShareStateEntity(item.id, {...item, name: item.fileName})
          );
        });
      });
  }

  resetStore(): void {
    this.soilAnalysisUploadStore.reset();
  }
}
